import plugin from 'tailwindcss/plugin';

const cardImage = plugin.withOptions(function () {
	return function ({ addComponents, theme, e }) {
		addComponents({
			[`.${e('card-image')}`]: {
				borderRadius: `var(--card-image-border-radius, ${theme('borderRadius.none')})`,
			},
		});
		addComponents({
			[`.${e('card-image-shadow')}`]: {
				borderRadius: `var(--card-image-border-radius, ${theme('borderRadius.none')})`,
			},
		});
	};
});

export default cardImage;
